import {CanActivate, CanActivateChild, RouterStateSnapshot, ActivatedRouteSnapshot, Router} from "@angular/router";
import {Injectable} from "@angular/core";

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private router:Router) {
  }

  canActivate(route:ActivatedRouteSnapshot, state:RouterStateSnapshot) {
    if (localStorage.getItem('currentUser')) {
      state.url == '/login' || state.url == '/register' ? this.router.navigate(['/home']) : null;
      return true;
    }
    else {
      if (state.url != '/login') {
        this.router.navigate(['/login']);
        return false;
      } else {
        return true;
      }
    }
  }

  canActivateChild(route:ActivatedRouteSnapshot, state:RouterStateSnapshot) {
    if (localStorage.getItem('currentUser')) {
      route.url[0].path == 'login' ? this.router.navigate(['/home']) : null;
      return true;
    }
    else {
      if (route.url[0].path != 'login') {
        this.router.navigate(['/login']);
        return false;
      } else {
        return true;
      }
    }
  }

}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/login.guard.ts